<vee-field v-slot="props" v-model="computedModelValue" :rules="rules" :name="name" :label="label || name"
    :validate-on-mount="validateOnMount">
    <input :id="id" :ref="`style ${refId}`" autocomplete="off" :data-qa-id="dataQaId" :class="inputClass, { 'mt-input--error': bannedWordIsPresent }, {'showNormalErrorBorder' : props?.errors?.length}, 'inputFieldClass',{ 'disabledFieldClass': disabled }" :accept="acceptType"
        :placeholder="placeholder" :disabled="disabled" :name="name" :type="type" class="mt-input mt-input--block"
        v-bind="props?.field" :readonly="readOnly" :multiple="multiple" @blur="handleBlur" @focus="focus" @keyup="keyUp"
        :maxlength="maxLength"
        @change="handleChange" @mouseover="mouseOver" @mouseout="mouseOut" @keydown.enter.prevent="handleEnterKeyDown"  @keyup.enter.prevent="handleEnterKeyUp">
    <md-typography class="counter"  v-if="showCounter && computedModelValue.length > 0" tag="span" color="spirits--700" variant="micro1--regular">
        {{computedModelValue.length}}/{{maxLength}}
    </md-typography>
    <MdTypography class="optionalText"  v-if="optionalText" tag="span" color="spirits--700" variant="body2--regular">
        {{optionalText}}
    </MdTypography>
    <div v-show="props?.errors?.length && showErrorMessage && !bannedWordIsPresent &&!warningWordIsPresent" class="mt-error-wrapper" :class="errorClass">
        <slot name="errorContent" :errors="props?.errors">
            <span v-for="(error, i) in props?.errors" :key="i" class="mt-error">
                {{ error }}
            </span>
        </slot>
    </div>
    <div v-if="bannedWordIsPresent && showBannedWordErrorMessage" class="mt-error" :class="errorClass">
        {{$t('pages.profile.foundry_profile.banned_word_error_message')}}
    </div>
    <div v-if="warningWordIsPresent && showWarningWordErrorMessage" class="mt-error warning" :class="errorClass" :style="{ color: '#DC5800' }">
        {{ $t('pages.profile.foundry_profile.warning_word_error_message', {words: warningWords.join('", "')}) }}
    </div>
</vee-field>